import { render, staticRenderFns } from "./Skills.vue?vue&type=template&id=5a7994b4&scoped=true"
import script from "./Skills.vue?vue&type=script&lang=js"
export * from "./Skills.vue?vue&type=script&lang=js"
import style0 from "./Skills.vue?vue&type=style&index=0&id=5a7994b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7994b4",
  null
  
)

export default component.exports